import React, { useEffect, useState, useRef } from 'react';
import producerb1lmatrix from './../../../images/producerb1lmatrix.png'
import producerb1rmatrix from './../../../images/producerb1rmatrix.png'
import producerb1llines from './../../../images/producerb1llines.png'
import ProducerImg2 from './../../../images/producerpgimg2.png'
import GetStartedBtn from './../../../images/get_started_btn.png'
import ShareBeatsCard from './../../../images/sharebeatscard.png'
import Footer from './../../Footer/Footer.js'
import ProducerWidget1 from './../../../images/producerimg1.jpg'
import ProducerWidget2 from './../../../images/producerimg2.png'
import ProducerWidget3 from './../../../images/producerimg3.jpg'
import ProducerWidget4 from './../../../images/producerimg4.png'
import ProducerWidget5 from './../../../images/producerimg5.jpg'
import ProducerWidget6 from './../../../images/producerimg6.png'
import GreyFlower from './../../../images/greyflower.png'
import NerveVerticalTxt from './../../../images/nerveverticaltxt.png'
import ArtistPgImg5 from './../../../images/artistpgimg5.png'
import ComingSoonBtn from './../../../images/comingsoonbutton.png'
import NerveBlackRose from './../../../images/blackrose.png'
import ProducerDetailsSquare from './../../../images/producerdetailssquare.png'
import producerhoriline from './../../../images/producerhoriline.png'
import producervertline from './../../../images/producervertline.png'
import N3rveLogo from "./../../../images/N3rveLogo.png"
import { useDraggable } from "react-use-draggable-scroll";
import './Producer.css'
import Navbar from '../../Navbar/Navbar';
import ProdcerDots1 from './../../../images/producerdots1.png'
import ProdcerDots2 from './../../../images/producerdots2.png'
import ProdcerDots3 from './../../../images/producerdots3.png'
import ProdcerDots4 from './../../../images/producerdots4.png'
import ProdcerDots5 from './../../../images/producerdots5.png'
import ProdcerDots6 from './../../../images/producerdots6.png'
import ProdcerDots7 from './../../../images/producerdots7.png'
import ProdcerDots8 from './../../../images/producerdots8.png'
import ProdcerDots9 from './../../../images/producerdots9.png'
import ProdcerDots10 from './../../../images/producerdots10.png'
import ProdcerDots11 from './../../../images/producerdots11.png'
import ProdcerDots12 from './../../../images/producerdots12.png'
import comingsoonbtn from './../../../images/comingsoonbtn.png'
import { Trans, useTranslation } from 'react-i18next'
import BtnTopLeft from './../../../images/btntopleft.png'
import BtnBottomRight from './../../../images/btnbottonright.png'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import { Parallax, ParallaxLayer } from '@react-spring/parallax'
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';
import { logtoWix } from "../../Helpers/LogToWix";
import { useJwt, decodeToken } from "react-jwt";


function Producers() {
  const { t, i18n } = useTranslation();
  const cookies = new Cookies(null, { path: '/' });
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  })
  const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
  // const ref = useRef(null); 
  // const ref2 = useRef(null); 
  // const { events } = useDraggable(ref); 
  // const { events:events2 } = useDraggable(ref2, {
  //   applyRubberBandEffect: true,
  // }); 
  const hasLogged = useRef(false);

  function topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  useEffect(() => {
    topFunction()
    window.addEventListener("resize", handleResize, false);
    if (!hasLogged.current) {
      if (cookies.get('token') !== undefined) {
        if (decodeToken(cookies.get('token')) !== null) {
          logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Producer Page", { "desc": "User opened the producer page" })
          hasLogged.current = true;
        } else {
          logtoWix("anonymous user", "pageview", "Producer Page", { "desc": "User opened the producer page" })
          hasLogged.current = true;
        }
      } else {
        logtoWix("anonymous user", "pageview", "Producer Page", { "desc": "User opened the producer page" })
        hasLogged.current = true;
      }
    }
  }, [])

  const handleResize = () => {
    // console.log(window.innerWidth)
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }


  return (
    <div style={{ width: '100vw' }}>

      {/* ******************************************** */}


      {/* DESKTOP VIEW */}

      {
        dimensions.width >= 1024 &&
        <div style={{ width: '100%', height: '100%' }}>
          <Parallax style={{ backgroundColor: '#15171B' }}>
            <ParallaxLayer offset={0} speed={0.4} factor={2.5} style={{
              width: '200vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'flex-end',
              paddingLeft: '17em',
              height: '100vh',
              backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/rzgwdo1vmhmmfpvfgtbn")`,
              backgroundSize: 'cover',
              backgroundRepeat: 'repeat',
              backgroundPositionX: '0vw',
              backgroundColor: '#15171B',
              zIndex: '-1'
            }}>


            </ParallaxLayer>

            <div style={{
              height: '100vh',
              // height:'50px',
              width: '100%',
              backgroundSize: 'cover',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'relative'

            }}>
              <div style={{ height: '100vh', width: '100%', backgroundImage: 'linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)' }} />

              <img src={producerb1llines} style={{ width: '0.75em', height: '8.18em', position: 'absolute', top: '10%', left: '3em' }} />
              <img src={producerb1lmatrix} style={{ width: '21.87em', height: '13.14em', position: 'absolute', bottom: '0em', left: '0em' }} />
              <img src={producerb1rmatrix} style={{ width: '21.87em', height: '13.14em', position: 'absolute', bottom: '0em', right: '0em' }} />

              <div style={{ position: 'absolute', bottom: '3em', left: '17%' }}>
                <div className='ForProducerTxt' style={{ alignSelf: 'flex-start', textAlign: 'center', marginTop: '0em', marginLeft: '0em', marginBottom: '1em' }}>
                  {t('ForProducer')}
                </div>

                <div className='SellBeatsOnlineTxt' style={{ marginTop: '0em', marginLeft: '0em', width: '7em', textAlign: 'left', fontSize: '4rem' }}>
                  <Trans i18nKey="YourbeatsyourinspoParralax" components={{ 1: <br /> }} >
                    Your Beats, <br />
                    Their Inspiration
                  </Trans>

                </div>

                <div className='SimplestWayTxt' style={{ marginLeft: '0em' }}>  {t('Simplestwaytotake')}</div>

                <div className='N3RVEBeatClubTxt' style={{ marginLeft: '0em', textAlign: 'left' }}>
                  {t('Welcometothespace')}
                </div>

                <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '15.5em', height: '4em', marginTop: '1.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                  <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                  <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
                  <div className="Comingsoonsmall">
                    {t('Comingsoon')}
                  </div>
                </div>

                <img src={ProdcerDots2} style={{ width: '5.5em', height: '0.18em', marginTop: '1.5em' }} />
              </div>

            </div>


            <div style={{
              // backgroundImage:`url(${ProducerImg2})`, 
              backgroundColor: '#15171B',
              height: '135.5em',
              // height:'50px',
              width: '100%',
              backgroundSize: 'cover',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'relative'
            }}>
              <img src={ProdcerDots4} style={{ position: 'absolute', width: '1.48em', height: '26.83em', left: '1.5%', top: '7.815em' }} />
              <img src={NerveBlackRose} style={{ position: 'absolute', width: '30.93em', height: '30.56em', left: '1.5%', top: '4.815em' }} />
              <img src={ProdcerDots6} style={{ position: 'absolute', width: '0.5em', height: '4.44em', left: '2.5%', top: '65.73em' }} />
              <img src={ProdcerDots6} style={{ position: 'absolute', width: '0.5em', height: '4.44em', left: '2.5%', top: '105.73em' }} />
              {/* 
                      <img src={ProdcerDots4} style={{position:'absolute',width:'1.48em',height:'26.83em',left:'3.66em',top:'50.815em'}}/>
                      <img src={ProdcerDots5} style={{position:'absolute',width:'6.61em',height:'7.008em',left:'1.16em',top:'79.312em'}}/>
                      <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'4.25em',top:'95.04em'}}/>
                      <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'4.25em',top:'127.73em'}}/>
                      <img src={ProdcerDots7} style={{position:'absolute',width:'0.375em',height:'0.414em',right:'10.048em',top:'45.75em'}}/>
                      <img src={ProdcerDots8} style={{position:'absolute',width:'0.79em',height:'0.25em',left:'2.89em',top:'125.9em'}}/>
                      <img src={ProdcerDots9} style={{position:'absolute',width:'5.91em',height:'3.04em',right:'6.18em',top:'150.85em'}}/> */}
              <img src={NerveVerticalTxt} style={{ position: 'absolute', width: '18.06em', height: '100.67em', right: '2.89em', top: '2em' }} />
              <div className={cookies.get('lang') === 'en' ? 'ProducerPgDiv2H1' : 'jp-ProducerPgDiv2H1'}>{t('Kickstartyourglobal')}</div>

              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '3.21em', justifyContent: 'center', width: '70%', position: 'relative' }}>

                <img src={ProducerWidget1} style={{ width: '22.5em', height: '15.18em', marginLeft: '-2.6em' }} />

                <div style={{ display: 'flex', flexDirection: 'column' }}>

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span className='KickstartWidgetHeaderR' style={{ textAlign: 'left' }}><span style={{ color: '#E91353' }}>\\</span>&nbsp; {t('Showcaseyourtalent')} </span>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginRight: '-5em', marginTop: '1em', marginLeft: '3em', zIndex: '2' }} />
                        <div className='KickstartWidgetDescR' style={{ textAlign: 'left' }}>
                          {t('Exposeyoutbeats')}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-end', marginRight: '-1.5em' }}>
                    <div className="div" style={{ width: '8.31em', height: '0.125em', backgroundColor: '#FF3874' }} />
                    <div className="div" style={{ width: '1.05em', height: '0.125em', backgroundColor: '#FF3874', marginLeft: '0.7em' }} />
                  </div>
                </div>

              </div>


              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5em', justifyContent: 'center', width: '70%' }}>

                <div style={{ display: 'flex', flexDirection: 'column' }}>

                  <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '-1em' }}>
                    <span className='KickstartWidgetHeaderL' style={{ textAlign: 'left' }}><span style={{ color: '#E91353' }}>\\</span>&nbsp;  {t('CreateandCollaborate')}</span>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginLeft: '-2em', zIndex: '2' }} />
                        <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)', marginLeft: '-1em', textAlign: 'left' }}>{t('Connectwithartist')}</div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start' }}>
                    <div className="div" style={{ width: '1.05em', height: '0.125em', backgroundColor: '#FF3874', marginLeft: '-2.2em' }} />
                    <div className="div" style={{ width: '8.31em', height: '0.125em', backgroundColor: '#FF3874', marginLeft: '0.5em' }} />

                  </div>
                </div>

                <img src={ProducerWidget2} style={{ width: '22.5em', height: '15.18em' }} />
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5em', justifyContent: 'center', width: '70%' }}>

                <img src={ProducerWidget3} style={{ width: '22.5em', height: '15.18em', marginLeft: '-2.6em' }} />

                <div style={{ display: 'flex', flexDirection: 'column' }}>

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span className='KickstartWidgetHeaderR' style={{ textAlign: 'left' }}><span style={{ color: '#E91353' }}>\\</span>&nbsp;{t('Monetizeyourcraft')} </span>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginRight: '-5em', marginTop: '1em', marginLeft: '3em', zIndex: '2' }} />
                        <div className='KickstartWidgetDescR' style={{ textAlign: 'left' }}>
                          {t('Setyourprices')}

                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-end', marginRight: '-1.5em' }}>
                    <div className="div" style={{ width: '8.31em', height: '0.125em', backgroundColor: '#FF3874' }} />
                    <div className="div" style={{ width: '1.05em', height: '0.125em', backgroundColor: '#FF3874', marginLeft: '0.7em' }} />
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5em', justifyContent: 'center', width: '70%' }}>

                <div style={{ display: 'flex', flexDirection: 'column' }}>

                  <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '-1em' }}>
                    <span className='KickstartWidgetHeaderL' style={{ textAlign: 'left' }}><span style={{ color: '#E91353' }}>\\</span>&nbsp; {t('Globalreach')}</span>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginLeft: '-2em', zIndex: '2' }} />
                        <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)', marginLeft: '-1em', textAlign: 'left' }}>{t('Gaininternatinal')}</div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start' }}>
                    <div className="div" style={{ width: '1.05em', height: '0.125em', backgroundColor: '#FF3874', marginLeft: '-2.2em' }} />
                    <div className="div" style={{ width: '8.31em', height: '0.125em', backgroundColor: '#FF3874', marginLeft: '0.5em' }} />

                  </div>
                </div>

                <img src={ProducerWidget4} style={{ width: '22.5em', height: '15.18em' }} />
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5em', justifyContent: 'center', width: '70%' }}>

                <img src={ProducerWidget5} style={{ width: '22.5em', height: '15.18em', marginLeft: '-2.6em' }} />

                <div style={{ display: 'flex', flexDirection: 'column' }}>

                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span className='KickstartWidgetHeaderR' style={{ textAlign: 'left' }}><span style={{ color: '#E91353' }}>\\</span>&nbsp;{t('Promotionandbranding')}</span>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginRight: '-5em', marginTop: '1em', marginLeft: '3em', zIndex: '2' }} />
                        <div className='KickstartWidgetDescR' style={{ textAlign: 'left' }}>
                          {t('Elevateyourproducer')}

                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-end', marginRight: '-1.5em' }}>
                    <div className="div" style={{ width: '8.31em', height: '0.125em', backgroundColor: '#FF3874' }} />
                    <div className="div" style={{ width: '1.05em', height: '0.125em', backgroundColor: '#FF3874', marginLeft: '0.7em' }} />
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '5em', justifyContent: 'center', width: '70%' }}>

                <div style={{ display: 'flex', flexDirection: 'column' }}>

                  <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '-1em' }}>
                    <span className='KickstartWidgetHeaderL' style={{ textAlign: 'left' }}><span style={{ color: '#E91353' }}>\\</span>&nbsp;{t('Exclusiveaccess')}</span>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>

                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginLeft: '-2em', zIndex: '2' }} />
                        <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)', marginLeft: '-1em', textAlign: 'left' }}>{t('Accessspecial')}</div>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start' }}>
                    <div className="div" style={{ width: '1.05em', height: '0.125em', backgroundColor: '#FF3874', marginLeft: '-2.2em' }} />
                    <div className="div" style={{ width: '8.31em', height: '0.125em', backgroundColor: '#FF3874', marginLeft: '0.5em' }} />

                  </div>
                </div>

                <img src={ProducerWidget6} style={{ width: '22.5em', height: '15.18em' }} />
              </div>



            </div>



            <div style={{
              backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/jck3g9wkhlliryxvt6ml")`,
              height: '38.18em',
              backgroundSize: 'cover',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              {/* <img src={ProdcerDots10} style={{position:'absolute',width:'0.75em',height:'8.25em',left:'2.5em',top:'226em'}}/> */}
              <img src={ProdcerDots12} style={{ position: 'absolute', width: '5.68em', height: '8.25em', right: '6.18em', top: '252.5em' }} />

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                marginTop: '10em',
                width: '65%'
              }}>
                <img src={N3rveLogo} style={{ width: '5.87em', height: '1.125em' }} />
                <div className='ProducerDiv4H1' style={{ textAlign: 'left' }} >
                  <Trans i18nKey="Shapethesound" components={{ 1: <br /> }} >
                    Shape The Sound <br /> Of Tomorrow
                  </Trans>

                </div>

                <div className='ProducerDiv4H3' style={{ textAlign: 'left' }}>
                  {t('Areyourreadytotake')}

                </div>

                <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '28.06em', height: '4em', marginTop: '1.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                  <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
                  <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
                  <div className="ApplyProducerbtn">
                    {t('Applytobeproducer')}
                  </div>
                </div>
              </div>
            </div>


            <Footer />
          </Parallax>
        </div>

        //     <div className="ProducerContainer">
        //      <div style={{ backgroundImage:`url(${ProducerImg1})`, 
        //                   height:'41.5em',
        //                   // height:'50px',
        //                   width:'100%',
        //                   backgroundSize:'cover',
        //                   display:'flex',
        //                   flexDirection:'column',
        //                   alignItems:'center'
        //                 }}>

        //             <div  style={{ 
        //                   width:'85%',
        //                   display:'flex',
        //                   flexDirection:'column',
        //                   alignItems:'flex-start'
        //                 }}>
        //             <div className='ForProducerTxt'>
        //               {t('ForProducer')}
        //               </div>

        //             <div className='SellBeatsOnlineTxt'>
        //             <Trans i18nKey="Yourbeatsyourinspo" components={{1:<br/>}} >
        //                 Your Beats, <br/>
        //                 Their Inspiration
        //               </Trans>

        //             </div>

        //             <div className='SimplestWayTxt'> {t('Simplestwaytotake')}</div>

        //             <div className='N3RVEBeatClubTxt'>
        //             {t('Welcometothespace')}
        //             </div>

        //             <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'15.5em',height:'4em', marginLeft:'14.53em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center'}} >
        //                     <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
        //                     <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
        //                     <div className="Comingsoonsmall">
        //                     {t('Comingsoon')}
        //                     </div>
        //                 </div>
        //               </div>
        //             <img src={ProdcerDots2} style={{position:'absolute',width:'5.5em',height:'0.18em',left:'14.5em',top:'35.125em'}}/>
        //             <img src={ProdcerDots3} style={{position:'absolute',width:'5.68em',height:'8.25em',right:'6.18em',top:'32.5em'}}/>
        //     </div>

        //     <div style={{ backgroundImage:`url(${ProducerImg2})`, 
        //                   height:'133.5em',
        //                   // height:'50px',
        //                   width:'100%',
        //                   backgroundSize:'cover',
        //                   display:'flex',
        //                   flexDirection:'column',
        //                   alignItems:'center'
        //                 }}>

        //             <img src={ProdcerDots4} style={{position:'absolute',width:'1.48em',height:'26.83em',left:'3.66em',top:'42.815em'}}/>
        //             <img src={ProdcerDots5} style={{position:'absolute',width:'6.61em',height:'7.008em',left:'1.16em',top:'79.312em'}}/>
        //             <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'4.25em',top:'95.04em'}}/>
        //             <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'4.25em',top:'127.73em'}}/>
        //             <img src={ProdcerDots7} style={{position:'absolute',width:'0.375em',height:'0.414em',right:'10.048em',top:'45.75em'}}/>
        //             <img src={ProdcerDots8} style={{position:'absolute',width:'0.79em',height:'0.25em',left:'2.89em',top:'125.9em'}}/>
        //             <img src={ProdcerDots9} style={{position:'absolute',width:'5.91em',height:'3.04em',right:'6.18em',top:'150.85em'}}/>

        //             <div className={cookies.get('lang') === 'en' ?  'ProducerPgDiv2H1': 'jp-ProducerPgDiv2H1'}>{t('Kickstartyourglobal')}</div>

        //             <div style={{display:'flex',flexDirection:'row',marginTop:'3.21em',justifyContent:'center',width:'100%'}}>
        //                 <img src={ProducerWidget1} style={{width:'22.5em',height:'15.18em',marginLeft:'-2.6em'}}/>

        //               <div style={{display:'flex',flexDirection:'column'}}>

        //                 <div style={{display:'flex',flexDirection:'column'}}>
        //                   <span className='ProducerWidgetHeaderR'><span style={{color:'#E91353'}}>\\</span>&nbsp; {t('Showcaseyourtalent')} </span>
        //                   <div style={{display:'flex',flexDirection:'row'}}>

        //                     <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
        //                     <img  src={ProducerDetailsSquare} style={{width:'2.36em',height:'2.36em',marginRight:'-5em',marginTop:'1em',marginLeft:'3em',zIndex:'2'}}/>
        //                       <div className='ProducerWidgetDescR'>
        //                         {t('Exposeyoutbeats')}
        //                       </div>
        //                       </div>
        //                   </div>
        //                 </div>
        //                 <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginRight:'-1.5em'}}>
        //                   <div style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874'}}/>
        //                   <div style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.7em'}}/>
        //                 </div>
        //               </div>

        //             </div>


        //             <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'100%'}}>

        //             <div style={{display:'flex',flexDirection:'column'}}>

        //             <div style={{display:'flex',flexDirection:'column',marginLeft:'-1em'}}>
        //               <span className='ProducerWidgetHeaderL'><span style={{color:'#E91353'}}>\\</span>&nbsp;  {t('CreateandCollaborate')}</span>
        //               <div style={{display:'flex',flexDirection:'row'}}>

        //                 <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
        //                 <img  src={ProducerDetailsSquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginLeft:'-2em',zIndex:'2'}}/>
        //                 <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)',marginLeft:'-1em'}}>{t('Connectwithartist')}</div>
        //                   </div>
        //               </div>
        //             </div>
        //             <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start'}}>
        //               <div style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'-2.2em'}}/>
        //               <div style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.5em'}}/>

        //             </div>
        //             </div>

        //                 <img src={ProducerWidget2} style={{width:'22.5em',height:'15.18em'}}/>
        //             </div>

        //             <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'100%'}}>

        //                 <img src={ProducerWidget3} style={{width:'22.5em',height:'15.18em',marginLeft:'-2.6em'}}/>

        //                 <div style={{display:'flex',flexDirection:'column'}}>

        //                 <div style={{display:'flex',flexDirection:'column'}}>
        //                   <span className='ProducerWidgetHeaderR'><span style={{color:'#E91353'}}>\\</span>&nbsp;{t('Monetizeyourcraft')} </span>
        //                   <div style={{display:'flex',flexDirection:'row'}}>

        //                     <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
        //                     <img  src={ProducerDetailsSquare} style={{width:'2.36em',height:'2.36em',marginRight:'-5em',marginTop:'1em',marginLeft:'3em',zIndex:'2'}}/>
        //                       <div className='ProducerWidgetDescR'>
        //                         {t('Setyourprices')}

        //                       </div>
        //                       </div>
        //                   </div>
        //                 </div>
        //                 <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginRight:'-1.5em'}}>
        //                   <div style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874'}}/>
        //                   <div style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.7em'}}/>
        //                 </div>
        //                 </div>
        //             </div>

        //             <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'100%'}}>

        //             <div style={{display:'flex',flexDirection:'column'}}>

        //               <div style={{display:'flex',flexDirection:'column',marginLeft:'-1em'}}>
        //                 <span className='ProducerWidgetHeaderL'><span style={{color:'#E91353'}}>\\</span>&nbsp; {t('Globalreach')}</span>
        //                 <div style={{display:'flex',flexDirection:'row'}}>

        //                   <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
        //                   <img  src={ProducerDetailsSquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginLeft:'-2em',zIndex:'2'}}/>
        //                   <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)',marginLeft:'-1em'}}>{t('Gaininternatinal')}</div>
        //                     </div>
        //                 </div>
        //               </div>
        //               <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start'}}>
        //                 <div style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'-2.2em'}}/>
        //                 <div style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.5em'}}/>

        //               </div>
        //             </div>

        //                 <img src={ProducerWidget4} style={{width:'22.5em',height:'15.18em'}}/>
        //             </div>

        //             <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'100%'}}>

        //                 <img src={ProducerWidget5} style={{width:'22.5em',height:'15.18em',marginLeft:'-2.6em'}}/>

        //                 <div style={{display:'flex',flexDirection:'column'}}>

        //                   <div style={{display:'flex',flexDirection:'column'}}>
        //                     <span className='ProducerWidgetHeaderR'><span style={{color:'#E91353'}}>\\</span>&nbsp;{t('Promotionandbranding')}</span>
        //                     <div style={{display:'flex',flexDirection:'row'}}>

        //                       <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
        //                       <img  src={ProducerDetailsSquare} style={{width:'2.36em',height:'2.36em',marginRight:'-5em',marginTop:'1em',marginLeft:'3em',zIndex:'2'}}/>
        //                         <div className='ProducerWidgetDescR'>
        //                         {t('Elevateyourproducer')}

        //                         </div>
        //                         </div>
        //                     </div>
        //                   </div>
        //                   <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-end',marginRight:'-1.5em'}}>
        //                     <div style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874'}}/>
        //                     <div style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.7em'}}/>
        //                   </div>
        //                   </div>
        //             </div>

        //             <div style={{display:'flex',flexDirection:'row',marginTop:'5em',justifyContent:'center',width:'100%'}}>

        //             <div style={{display:'flex',flexDirection:'column'}}>

        //               <div style={{display:'flex',flexDirection:'column',marginLeft:'-1em'}}>
        //                 <span className='ProducerWidgetHeaderL'><span style={{color:'#E91353'}}>\\</span>&nbsp;{t('Exclusiveaccess')}</span>
        //                 <div style={{display:'flex',flexDirection:'row'}}>

        //                   <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
        //                   <img  src={ProducerDetailsSquare} style={{width:'2.36em',height:'2.36em',marginTop:'1em',marginLeft:'-2em',zIndex:'2'}}/>
        //                   <div className='ProducerWidgetDescL' style={{clipPath:'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)',marginLeft:'-1em'}}>{t('Accessspecial')}</div>
        //                     </div>
        //                 </div>
        //               </div>
        //               <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start'}}>
        //                 <div style={{width:'1.05em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'-2.2em'}}/>
        //                 <div style={{width:'8.31em',height:'0.125em',backgroundColor:'#FF3874',marginLeft:'0.5em'}}/>

        //               </div>
        //             </div>

        //                 <img src={ProducerWidget6} style={{width:'22.5em',height:'15.18em'}}/>
        //             </div>

        //     </div>

        //     <div style={{backgroundImage:`url(${ArtistPgImg5})`,height:'45em',width:'100%', backgroundSize:'cover'}}>
        //           <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
        //                 <div className='WhyChooseUsTxt'>
        //                 <Trans i18nKey="whyproducerchooseus" components={{1:<br/>}} >
        //                 Why Producers <br/> Choose Us?
        //                   </Trans>

        //                 </div>

        //                 <div style={{display:'flex',flexDirection:'column',marginTop:'5em',marginLeft:'7.5em'}}>

        //                     <div className='WhyChooseUsTitle'>
        //                     {t('Directtoartist')}
        //                     </div>

        //                     <div className='WhyChooseUsDesc'>
        //                     {t('Setyourterms')}

        //                     </div>



        //                     <div className='WhyChooseUsTitle'>
        //                     {t('Unrivaledcollabs')}

        //                     </div>

        //                     <div className='WhyChooseUsDesc'>
        //                     {t('Createalongartist')}

        //                     </div>



        //                     <div className='WhyChooseUsTitle'>
        //                     {t('Fullcontrol')}

        //                     </div>

        //                     <div className='WhyChooseUsDesc'>
        //                     {t('Retainfullown')}

        //                     </div>



        //                     <div className='WhyChooseUsTitle'>
        //                     {t('Worldwideexpose')}

        //                     </div>

        //                     <div className='WhyChooseUsDesc'>
        //                     {t('Weconnectyouwithart')}

        //                     </div>



        //                     <div className='WhyChooseUsTitle'>
        //                     {t('Resourcepowerhouse')}

        //                     </div>

        //                     <div className='WhyChooseUsDesc'>
        //                     {t('Withmarketingandbranding')}

        //                     </div>


        //                 </div>
        //           </div>
        //     </div>

        //     <div style={{backgroundImage:`url(${ProducerImg3})`,
        //                        height:'38.18em',
        //                        backgroundSize:'cover',
        //                        display:'flex',
        //                        flexDirection:'column',
        //                        alignItems:'center'
        //                       }}>
        //                 <img src={ProdcerDots10} style={{position:'absolute',width:'0.75em',height:'8.25em',left:'2.5em',top:'226em'}}/>
        //                 <img src={ProdcerDots12} style={{position:'absolute',width:'5.68em',height:'8.25em',right:'6.18em',top:'252.5em'}}/>

        //                 <div style={{
        //                        display:'flex',
        //                        flexDirection:'column',
        //                        alignItems:'flex-start',
        //                        marginTop:'10em',
        //                        width:'65%'
        //                       }}>
        //                 <img src={N3rveLogo} style={{width:'5.87em',height:'1.125em'}}/>
        //                 <div className='ProducerDiv4H1'>
        //                 <Trans i18nKey="Shapethesound" components={{1:<br/>}} >
        //                     Shape The Sound <br/> Of Tomorrow
        //                   </Trans>

        //                 </div>

        //                 <div className='ProducerDiv4H3'>
        //                   {t('Areyourreadytotake')}

        //                 </div>

        //                  <div style={{border:'0.5px solid rgba(255,255,255,30%)',width:'28.06em',height:'4em', marginTop:'1.5em',position:'relative',display:'flex',alignItems:'center',justifyContent:'center'}} >
        //                     <img src={BtnTopLeft} style={{width:'0.8125em',height:'0.8125em',position:'absolute',top:'-0.1em',left:'-0.1em'}}/>
        //                     <img src={BtnBottomRight} style={{width:'0.8125em',height:'0.8125em',position:'absolute',bottom:'-0.1em',right:'-0.1em'}}/>
        //                     <div className="ApplyProducerbtn">
        //                     {t('Applytobeproducer')}
        //                     </div>
        //                 </div>
        //                 </div>
        //     </div>


        //     <Footer/>

        // </div>
      }




      {/* /****************************************************************************** */}

      {/* /** TABLET VIEW */}
      {
        dimensions.width >= 768 && dimensions.width < 1024 &&
        <div className="ProducerContainer">
          <div style={{
            backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/rzgwdo1vmhmmfpvfgtbn")`,
            height: '33em',
            // height:'50px',
            width: '100%',
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative'
          }}>

            <div style={{ height: '100%', width: '100%', backgroundImage: 'linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)', position: 'absolute', zIndex: '1' }} />
            <div className='ForProducerTxt' style={{ marginLeft: '0em', marginTop: '5.035em', width: '9.3125em', zIndex: '2' }}>
              {t('ForProducer')}
            </div>

            <div className='SellBeatsOnlineTxt' style={{ marginLeft: '0em', marginTop: '0.5em', textAlign: 'center', fontSize: '3rem', fontWeight: '500', zIndex: '2' }}>
              <Trans i18nKey="Yourbeatsyourinspo" components={{ 1: <br /> }} >
                Your Beats, <br />
                Their Inspiration
              </Trans>

            </div>

            <div className='SimplestWayTxt' style={{ marginLeft: '0em', marginTop: '1.125em', textAlign: 'center', fontSize: '1.125rem', fontWeight: '600', zIndex: '2' }}>
              {t('Simplestwaytotake')}</div>

            <div className='N3RVEBeatClubTxt' style={{ marginLeft: '0em', marginTop: '1.125em', textAlign: 'center', fontSize: '1rem', fontWeight: '400', zIndex: '2' }}>
              {t('Welcometothespace')}
            </div>

            <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '15.5em', height: '4em', marginLeft: '0em', marginTop: '1.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: '2' }} >
              <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
              <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
              <div className="Comingsoonsmall">
                {t('Comingsoon')}
              </div>
            </div>

            <img src={ProdcerDots2} style={{ position: 'absolute', width: '5.5em', height: '0.18em', left: '25.5em', top: '28.125em', zIndex: '2' }} />
            <img src={ProdcerDots3} style={{ position: 'absolute', width: '5.68em', height: '8.25em', right: '6.18em', top: '32.5em', zIndex: '2' }} />
          </div>

          <div style={{
            backgroundImage: `url(${ProducerImg2})`,
            height: '210em',
            // height:'50px',
            width: '100%',
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>

            <img src={ProdcerDots4} style={{ position: 'absolute', width: '1.48em', height: '26.83em', left: '3.66em', top: '42.815em' }} />
            <img src={ProdcerDots5} style={{ position: 'absolute', width: '6.61em', height: '7.008em', left: '1.16em', top: '79.312em' }} />
            <img src={ProdcerDots6} style={{ position: 'absolute', width: '0.5em', height: '4.44em', left: '4.25em', top: '95.04em' }} />
            <img src={ProdcerDots6} style={{ position: 'absolute', width: '0.5em', height: '4.44em', left: '4.25em', top: '127.73em' }} />
            <img src={ProdcerDots7} style={{ position: 'absolute', width: '0.375em', height: '0.414em', right: '10.048em', top: '45.75em' }} />
            <img src={ProdcerDots8} style={{ position: 'absolute', width: '0.79em', height: '0.25em', left: '2.89em', top: '125.9em' }} />
            <img src={ProdcerDots9} style={{ position: 'absolute', width: '5.91em', height: '3.04em', right: '6.18em', top: '150.85em' }} />

            <div className={cookies.get('lang') === 'en' ? 'ProducerPgDiv2H1' : 'jp-ProducerPgDiv2H1'} style={{ marginLeft: '0em', marginTop: '1.18em', textAlign: 'center', fontSize: '2.5rem', fontWeight: '500', width: '80%' }}>{t('Kickstartyourglobal')}</div>

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget1} style={{ width: '70%', height: '17.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.5rem', fontWeight: '500', lineHeight: '140%', width: '70%' }}>
                {t('Showcaseyourtalent')} &nbsp; <span style={{ color: '#E91353' }}>//</span></span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '70%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Exposeyoutbeats')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '8em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>





            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget2} style={{ width: '70%', height: '17.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.5rem', fontWeight: '500', lineHeight: '140%', width: '70%' }}>
                <span style={{ color: '#E91353' }}>\\</span> &nbsp; {t('CreateandCollaborate')}</span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '70%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Connectwithartist')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '8em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>




            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget3} style={{ width: '70%', height: '17.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.5rem', fontWeight: '500', lineHeight: '140%', width: '70%' }}>
                {t('Monetizeyourcraft')} &nbsp; <span style={{ color: '#E91353' }}>//</span></span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '70%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Setyourprices')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '8em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>




            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget4} style={{ width: '70%', height: '17.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.5rem', fontWeight: '500', lineHeight: '140%', width: '70%' }}>
                <span style={{ color: '#E91353' }}>\\</span> &nbsp; {t('Globalreach')}</span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '70%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Gaininternatinal')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '8em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>



            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget5} style={{ width: '70%', height: '17.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.5rem', fontWeight: '500', lineHeight: '140%', width: '70%' }}>
                {t('Promotionandbranding')} &nbsp; <span style={{ color: '#E91353' }}>//</span></span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '70%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Elevateyourproducer')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '8em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>



            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget6} style={{ width: '70%', height: '17.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.5rem', fontWeight: '500', lineHeight: '140%', width: '70%' }}>
                <span style={{ color: '#E91353' }}>\\</span> &nbsp; {t('Exclusiveaccess')}</span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '70%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Accessspecial')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '8em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>


          </div>

          <div style={{
            backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/jck3g9wkhlliryxvt6ml")`,
            height: '32.18em',
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            {/* <img src={ProdcerDots10} style={{position:'absolute',width:'0.75em',height:'8.25em',left:'2.5em',top:'226em'}}/> */}
            <img src={ProdcerDots12} style={{ position: 'absolute', width: '5.68em', height: '8.25em', right: '6.18em', top: '252.5em' }} />

            <img src={N3rveLogo} style={{ width: '5.87em', height: '1.125em', marginTop: '6.31em' }} />
            <div className='ProducerDiv4H1' style={{ fontSize: '3em', textAlign: 'center', marginTop: '0.3em', fontWeight: '500' }}>
              <Trans i18nKey="Shapethesound" components={{ 1: <br /> }} >
                Shape The Sound <br /> Of Tomorrow
              </Trans>

            </div>

            <div className='ProducerDiv4H3' style={{ fontSize: '1rem', textAlign: 'left', marginTop: '1.5em', fontWeight: '400', width: '60%' }}>
              {t('Areyourreadytotake')}

            </div>

            <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '27.31em', height: '4em', marginTop: '1.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} >
              <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
              <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
              <div className="ApplyProducerbtn" style={{ width: '95%', height: '1.5em' }}>
                {t('Comingsoon')}
              </div>
            </div>
          </div>


          <Footer />

        </div>
      }





      {/* /****************************************************************************** */}

      {/* /** MOBILE VIEW */}
      {
        dimensions.width < 768 &&
        <div className="ProducerContainer">
          <div style={{
            backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/rzgwdo1vmhmmfpvfgtbn")`,
            height: '32.875em',
            // height:'50px',
            width: '100%',
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative'
          }}>

            <div style={{ height: '100%', width: '100%', backgroundImage: 'linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 100%)', position: 'absolute', zIndex: '1' }} />
            <div className='ForProducerTxtMob'>
              {t('ForProducer')}
            </div>

            <div className='SellBeatsOnlineTxt' style={{ marginLeft: '0em', marginTop: '1.18em', textAlign: 'center', fontSize: '1.75rem', fontWeight: '500', zIndex: '2' }}>
              <Trans i18nKey="Yourbeatsyourinspo" components={{ 1: <br /> }} >
                Your Beats, <br />
                Their Inspiration
              </Trans>

            </div>

            <div className='SimplestWayTxt' style={{ marginLeft: '0em', marginTop: '1.18em', textAlign: 'center', fontSize: '0.975rem', fontWeight: '600', zIndex: '2' }}> {t('Simplestwaytotake')}</div>

            <div className='N3RVEBeatClubTxt' style={{ marginLeft: '0em', marginTop: '1.18em', textAlign: 'center', fontSize: '1rem', fontWeight: '400', width: '80%', zIndex: '2' }}>
              {t('Welcometothespace')}
            </div>

            <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '15.5em', height: '4em', marginLeft: '0em', marginTop: '1.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: '2' }} >
              <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
              <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
              <div className="Comingsoonsmall">
                {t('Comingsoon')}
              </div>
            </div>

            {/* <img src={ProdcerDots2} style={{position:'absolute',width:'5.5em',height:'0.18em',left:'10em',top:'28.125em',zIndex:'2'}}/>
                <img src={ProdcerDots3} style={{position:'absolute',width:'5.68em',height:'8.25em',right:'3.18em',top:'32.5em',zIndex:'2'}}/> */}
          </div>

          <div style={{
            // backgroundImage:`url(${ProducerImg2})`, 
            // backgroundSize:'100%',
            // height:'195.5em',
            backgroundColor: '#15171B',
            // height:'50px',
            paddingBottom: '5em',
            width: '100%',
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>

            {/* <img src={ProdcerDots4} style={{position:'absolute',width:'1.48em',height:'26.83em',left:'0em',top:'37.815em'}}/> */}
            {/* <img src={ProdcerDots5} style={{position:'absolute',width:'6.61em',height:'7.008em',left:'1.16em',top:'79.312em'}}/> */}
            {/* <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'0em',top:'87.04em'}}/>
                <img src={ProdcerDots6} style={{position:'absolute',width:'0.5em',height:'4.44em',left:'0.25em',top:'119.73em'}}/>
                <img src={ProdcerDots7} style={{position:'absolute',width:'0.375em',height:'0.414em',right:'10.048em',top:'45.75em'}}/>
                <img src={ProdcerDots8} style={{position:'absolute',width:'0.79em',height:'0.25em',left:'2.89em',top:'125.9em'}}/>
                <img src={ProdcerDots9} style={{position:'absolute',width:'5.91em',height:'3.04em',right:'6.18em',top:'150.85em'}}/> */}

            <div className={cookies.get('lang') === 'en' ? 'ProducerPgDiv2H1' : 'jp-ProducerPgDiv2H1'} style={{ marginLeft: '0em', marginTop: '1.18em', textAlign: 'center', fontSize: '1.75em', fontWeight: '500', width: '80%' }}>{t('Kickstartyourglobal')}</div>

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget1} style={{ width: '80%', height: '15.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.125rem', fontWeight: '600', lineHeight: '120%', width: '90%' }}>
                {t('Showcaseyourtalent')} &nbsp; <span style={{ color: '#E91353' }}>//</span></span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '80%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Exposeyoutbeats')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '2.4em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>





            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget2} style={{ width: '80%', height: '15.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.125rem', fontWeight: '600', lineHeight: '120%', width: '90%' }}>
                <span style={{ color: '#E91353' }}>\\</span> &nbsp; {t('CreateandCollaborate')}</span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '80%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Connectwithartist')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '2.4em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>




            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget3} style={{ width: '80%', height: '15.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.125rem', fontWeight: '600', lineHeight: '120%', width: '90%' }}>
                {t('Monetizeyourcraft')} &nbsp; <span style={{ color: '#E91353' }}>//</span></span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '80%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Setyourprices')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '2.4em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>




            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget4} style={{ width: '80%', height: '15.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.125rem', fontWeight: '600', lineHeight: '120%', width: '90%' }}>
                <span style={{ color: '#E91353' }}>\\</span> &nbsp; {t('Globalreach')}</span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '80%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Gaininternatinal')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '2.4em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>



            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget5} style={{ width: '80%', height: '15.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.125rem', fontWeight: '600', lineHeight: '120%', width: '90%' }}>
                {t('Promotionandbranding')} &nbsp; <span style={{ color: '#E91353' }}>//</span></span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '80%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Elevateyourproducer')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '2.4em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>



            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '3.21em', alignItems: 'center', width: '100%' }}>
              <img src={ProducerWidget6} style={{ width: '80%', height: '15.62em' }} />


              <span className='KickstartWidgetHeaderR' style={{ fontSize: '1.125rem', fontWeight: '600', lineHeight: '120%', width: '90%' }}>
                <span style={{ color: '#E91353' }}>\\</span> &nbsp; {t('Exclusiveaccess')}</span>

              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '80%', alignSelf: 'center' }}>
                <img src={ProducerDetailsSquare} style={{ width: '2.36em', height: '2.36em', marginTop: '1em', marginRight: '-1em', zIndex: '2' }} />
                <div className='KickstartWidgetDescL' style={{ clipPath: 'polygon(0 0,calc(100% - 38.00px) 0,100% 38.00px,100% 100%,0 100%)' }}>
                  {t('Accessspecial')}
                </div>
              </div>




              <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-start', marginLeft: '2.4em' }}>
                <div style={{ width: '1.05em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)' }} />
                <div style={{ width: '8.31em', height: '0.125em', backgroundImage: 'linear-gradient(270.16deg, #9C4FFF 0%, rgba(130, 119, 255, 0.4) 99.72%)', marginLeft: '0.7em' }} />
              </div>


            </div>


          </div>



          <div style={{
            backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/jck3g9wkhlliryxvt6ml")`,
            height: '38.18em',
            backgroundSize: 'cover',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            {/* <img src={ProdcerDots10} style={{position:'absolute',width:'0.75em',height:'8.25em',left:'2.5em',top:'226em'}}/>
                    <img src={ProdcerDots12} style={{position:'absolute',width:'5.68em',height:'8.25em',right:'6.18em',top:'252.5em'}}/> */}

            <img src={N3rveLogo} style={{ width: '5.87em', height: '1.125em', marginTop: '5em' }} />
            <div className='ProducerDiv4H1' style={{ fontSize: '1.75em', textAlign: 'center', marginTop: '1em', fontWeight: '500' }}>
              <Trans i18nKey="Shapethesound" components={{ 1: <br /> }} >
                Shape The Sound <br /> Of Tomorrow
              </Trans>

            </div>

            <div className='ProducerDiv4H3' style={{ fontSize: '1em', textAlign: 'left', marginTop: '1.5em', fontWeight: '400', width: '80%' }}>
              {t('Areyourreadytotake')}

            </div>

            <div style={{ border: '0.5px solid rgba(255,255,255,30%)', width: '80%', height: '4em', marginTop: '1.5em', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} >
              <img src={BtnTopLeft} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', top: '-0.1em', left: '-0.1em' }} />
              <img src={BtnBottomRight} style={{ width: '0.8125em', height: '0.8125em', position: 'absolute', bottom: '-0.1em', right: '-0.1em' }} />
              <div className="ApplyProducerbtn" style={{ width: '95%', height: '1.5em' }}>
                {t('Comingsoon')}
              </div>
            </div>

          </div>


          <Footer />

        </div>
      }



    </div>
  );
}

export default Producers;